import moment from 'moment';
import BN from 'bignumber.js';
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Container, Divider, Button, Dimmer, Message, Loader, Checkbox } from 'semantic-ui-react';
import Styles from './styles.css';
import { MembershipBillingDayModal } from './membershipBillingDayModal';
import { TerminateMembershipModal } from './terminateMembershipModal';

export class MembershipInfo extends React.Component {
  state = {}

  resumeMembership = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { accountId, onUpdate } = this.props;
      const { status, body } = await fetchApi({
        url: `/payments/programs/${accountId}/membership/resume`,
        body: {},
      });

      if (status === 200) {
        if (onUpdate) {
          onUpdate();
        }
        this.setState({ loading: false });
      } else {
        this.setState({ error: body, loading: false });
      }
    });
  }

  provisionMembership = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { accountId, onUpdate } = this.props;
      const { status, body } = await fetchApi({
        url: `/payments/programs/${accountId}/membership/provision`,
        body: {},
      });

      if (status === 200) {
        if (onUpdate) {
          onUpdate();
        }
        this.setState({ loading: false });
      } else {
        this.setState({ error: body, loading: false });
      }
    });
  }

  toggleRenewal = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { accountId, onUpdate, membership } = this.props;
      const { status, body } = await fetchApi({
        url: `/payments/programs/${accountId}/membership/renewal`,
        body: {
          should_renew: !membership.renewal_details.should_renew,
        },
      });

      if (status === 200) {
        if (onUpdate) {
          onUpdate();
        }
        this.setState({ loading: false });
      } else {
        this.setState({ error: body, loading: false });
      }
    });
  }

  render() {
    const { loading, error } = this.state;
    const { membership, instruments, accountId, onUpdate } = this.props;
    const activeCard = instruments.find(i => !i.deleted && i.instrument_type === 'private_card' && i.provider_name === 'gasbuddy' && i.extra_data?.tags?.includes('active'));
    // TODO: Make this more robust with respect to expired membership etc.
    const provisioned = !!membership.membership_start;
    const { renewal_details: renewalDetails, billing_details: billingDetails } = membership;
    const scheduledExpiryDate = provisioned && !billingDetails ? membership.membership_end : null;
    const scheduledMigrationToPlan = billingDetails?.offering?.program_name;
    return (
      <Dimmer.Dimmable dimmed={loading}>
        {error && (
          <Message negative>
            <Message.Header>Oops - Changes Failed</Message.Header>
            <pre>{`${error.message}`}</pre>
          </Message>
        )}
        <Dimmer active={loading}>
          <Loader />
        </Dimmer>

        <div>
          <strong>Status: </strong>
          {(provisioned && 'Active')
            || `Unprovisioned (${
              (!activeCard && 'Waiting on card activation')
              || '🤷'
            })`}
          <Button floated="right" size="tiny" onClick={e => this.provisionMembership(e)}>{provisioned ? 'Force Provision' : 'Provision Now'}</Button>
          <Divider />
        </div>

        <div>
          <b>Program: </b>
          {membership.is_premium ? 'Premium' : 'Plus'}
          <Divider />
        </div>

        {renewalDetails && (
          <div>
            <strong>Renewal: </strong>
            {renewalDetails?.date && `${moment(renewalDetails.date).format('MMM Do YYYY')} @ $${new BN(renewalDetails.offering.renewal_price).toFixed(2)}/${renewalDetails.offering.period_type}`}
            <Checkbox
              className={Styles.right}
              toggle
              checked={renewalDetails.should_renew}
              onChange={e => this.toggleRenewal(e)}
            />
            <Divider />
          </div>
        )}

        {membership.roadside_member_id && (
          <div>
            <b>Roadside Member ID: </b>
            {membership.roadside_member_id || 'N/A'}
            <Divider />
          </div>
        )}

        <div>
          <b>Refresh Day: </b>
          {membership.refresh_day || 'N/A'}
          <Divider />
        </div>
        <div>
          <b>Qty Used/Remaining: </b>
          {`${membership.qty_used} / ${membership.qty_remaining}`}
          <Divider />
        </div>

        {scheduledExpiryDate && (
          <div>
            <b>Termination date: </b>
            {`${moment(scheduledExpiryDate).format('MMM Do YYYY')}`}
            <Button floated="right" size="tiny" onClick={e => this.resumeMembership(e)}>Resume</Button>
            <Divider />
          </div>
        )}
        {scheduledMigrationToPlan && (
          <div>
            <b>Migration scheduled: </b>
            {`To "${scheduledMigrationToPlan}" on ${moment(billingDetails.date).format('MMM Do YYYY')}`}
            <Button floated="right" size="tiny" onClick={e => this.resumeMembership(e)}>Cancel migration</Button>
            <Divider />
          </div>
        )}

        <Container fluid textAlign="right">
          <TerminateMembershipModal
            provisioned={provisioned}
            scheduledExpiryDate={scheduledExpiryDate}
            endDate={membership.membership_end}
            accountId={accountId}
            onUpdate={onUpdate}
          />
          {!scheduledExpiryDate && renewalDetails?.date && <MembershipBillingDayModal accountId={accountId} onUpdate={onUpdate} />}
        </Container>
      </Dimmer.Dimmable>
    );
  }
}

MembershipInfo.propTypes = {
  accountId: PT.number,
  program: PT.shape({
    program_id: PT.number,
    program_name: PT.string,
    activated_at: PT.string,
    extra_data: PT.object,
  }),
  membership: PT.shape({
    roadside_member_id: PT.string,
    membership_start: PT.string,
    refresh_day: PT.string,
  }),
  instruments: PT.arrayOf(PT.shape()),
  onUpdate: PT.func,
};

MembershipInfo.defaultProps = {
  accountId: 0,
  program: {
    program_id: 0,
    program_name: '',
    activated_at: null,
    extra_data: null,
  },
  membership: {},
  instruments: [],
  onUpdate: null,
};
